<section class="map-sidebar-items">
    @if (displayAsList) {
        <div
            class="map-sidebar-items__list"
        >
            @for (item of [0, 1, 2, 3, 4, 5, 6, 7]; track $index) {
                <article
                    class="map-sidebar-item"
                >
                    <div class="map-sidebar-item__icon">
                        <p-skeleton shape="circle" size="2rem"/>
                    </div>
                    <div class="map-sidebar-item__text">
                        <p-skeleton
                            width="60%"
                            height="1.25rem"
                        />
                        <p-skeleton
                            width="80%"
                            height="1rem"
                        />
                    </div>
                </article>
            }
        </div>
    } @else {
        <div
            class="map-sidebar-items__raster"
        >
            @for (item of [0, 1, 2, 3]; track $index) {
                <div
                    class="map-sidebar-item"
                >
                    <div class="map-sidebar-item__image">
                        <p-skeleton
                            class="item-image"
                            width="100%"
                            height="16vh"
                        />
                    </div>
                    <div class="map-sidebar-item__text">
                        <p-skeleton
                            width="80%"
                            height="1.25rem"
                        />
                        <p-skeleton
                            width="60%"
                            height=".9rem"
                            class="mt-xs"
                        />
                        <p-skeleton
                            width="60%"
                            height=".9rem"
                        />
                        <p-skeleton
                            width="90%"
                            height=".9rem"
                            class="mt-m"
                        />
                    </div>
                </div>
            }
        </div>
    }
</section>
